
define('tpl!taoQtiItem/qtiCreator/tpl/forms/static/include', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div class=\"panel\">\n    <label for=\"href\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "File", options) : helperMissing.call(depth0, "__", "File", options)))
    + "</label>\n    <span class=\"icon-help tooltipstered\" data-tooltip=\"~ .tooltip-content:first\" data-tooltip-theme=\"info\"></span>\n    <div class=\"tooltip-content\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "The file path to the shared stimulus.", options) : helperMissing.call(depth0, "__", "The file path to the shared stimulus.", options)))
    + "</div>\n    <input type=\"text\" name=\"href\" value=\"";
  if (helper = helpers.href) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.href); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-validate=\"$notEmpty;\" readonly/>\n    <button class=\"btn-info small block\" data-role=\"upload-trigger\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Select shared stimulus", options) : helperMissing.call(depth0, "__", "Select shared stimulus", options)))
    + "</button>\n</div>";
  return buffer;
  });
});

